import { useEffect } from "react";
import { animate, motion, useMotionValue, useTransform } from "motion/react";

interface AnimatedCounterProps {
  to: number;
  /** Counts up when this flips true; resets to 0 when false. */
  active: boolean;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  duration?: number;
  className?: string;
}

export function AnimatedCounter({
  to,
  active,
  prefix = "",
  suffix = "",
  decimals = 0,
  duration = 1.4,
  className = "",
}: AnimatedCounterProps) {
  const value = useMotionValue(0);
  const text = useTransform(value, (v) => {
    const num = decimals > 0 ? v.toFixed(decimals) : Math.round(v).toLocaleString("en-AU");
    return `${prefix}${num}${suffix}`;
  });

  useEffect(() => {
    if (!active) {
      value.set(0);
      return;
    }
    const controls = animate(value, to, { duration, ease: "easeOut" });
    return () => controls.stop();
  }, [active, to, duration, value]);

  return <motion.span className={`tabular-nums ${className}`}>{text}</motion.span>;
}
